import React from 'react';
import PropTypes from 'prop-types';
import SystemSpecsPanels from './systemSpecsPanels';

import '../saleslogic.css';
import { Title } from '../styles';
import '../../../../../../grid.css';

const SystemSpecs = (props) => {
    const {
        resiToggle, provider, projectState,
        firstName, solarPanel, inverter, includeESS, batteryType, systemNotes,
    } = props;
    let building = 'home';
    if (resiToggle === false) {
        building = 'building';
    }


    const terms = {
        building,
        provider,
        projectState,
        firstName,
        inverter,
        solarPanel,
        includeESS,
        resiToggle,
        batteryType,
        systemNotes,
    };

    return (
        <div>
            <Title>Know What You&#39;re Buying</Title>
            <SystemSpecsPanels terms={terms} />
        </div>
    );
};
SystemSpecs.propTypes = {
    resiToggle: PropTypes.bool.isRequired,
    includeESS: PropTypes.bool.isRequired,
    provider: PropTypes.number.isRequired,
    projectState: PropTypes.number.isRequired,
    firstName: PropTypes.string.isRequired,
    solarPanel: PropTypes.string.isRequired,
    inverter: PropTypes.string.isRequired,
    batteryType: PropTypes.string.isRequired,
    systemNotes: PropTypes.string.isRequired,
};

export default SystemSpecs;



// WEBPACK FOOTER //
// ./src/containers/Simulator/TabBar/Results/SalesLogic/SystemSpecs/SystemSpecs.js